import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertRTOReceiverAddress, convertRTOSenderAddress, convertTextToID } from "../../../../utils/GlobalFunction";
import moment from "moment";
export default class ManageReturnToOriginEntryStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	deleteValues = null;
	statusValues = null;
	viewValues = null;
	total = 0;
	allColumnIds = [];
	dropdown_city_list = null;
	isBookingFilter = null;
	isActiveFilterList = null;
	isServiceFilterList = null;
	isReturnResFilterList = null;
	consignmentValues = null;
	printData = null;
	selectionListEntries = null
	visibleRowCount = 0;
	selectedRowCount = 0;
	selectAllArr = []
	isSelectAll = false;

	// set form values to view
	setViewValues = (data) => {
		if (data) {
			data.r_address1 = convertRTOReceiverAddress(data);
			data.s_address1 = convertRTOSenderAddress(data);
		}
		this.viewValues = data;
	};

	// set values for print
	setPrintValues = (data) => {
		this.printValues = data;
	};

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to status
	setStatusValues = (data) => {
		this.statusValues = data;
	};

	setIsReturnResFilterList = (data) => {
		this.isReturnResFilterList = data;
	}

	setIsActiveFilterList = (data) => {
		this.isActiveFilterList = data;
	}

	setBookingFilterList = (data) => {
		this.isBookingFilter = data;
	}

	setServiceFilterList = (data) => {
		this.isServiceFilterList = data;
	}

	setConsignmentValues = (data) => {
		this.consignmentValues = data
	}

	setSelectionListEntries = (data) => {
		this.selectionListEntries = data
	}

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		this.agGrid.api.setFilterModel({
			entry_date: { dateFrom: moment().format("YYYY-MM-DD"), dateTo: moment().format("YYYY-MM-DD"), type: "inRange", filterType: "date" }
		})
		let datasource = this.createDatasource(ServerGridConfig.options);

		api.setServerSideDatasource(datasource)
	};

	// change page size, default page size is ServerGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// call api to get records
	getList = (payload) => {
		return Axios.post(`bookings/return-to-origin/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					this.setVisibleRowCount(this.visibleRowCount + 1)
					return null;
				});
			}
			if (this.visibleRowCount > 0 && this.visibleRowCount !== this.selectedRowCount) {
				this.setIsSelectAll(false)
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		if (final_filter["is_received"]) {
			final_filter['is_received'].values = convertTextToID(final_filter['is_received'], this.isActiveFilterList, 'name', 'id')
		}
		if (final_filter["catg_id"]) {
			final_filter['catg_id'].values = convertTextToID(final_filter['catg_id'], this.isBookingFilter, 'name', 'id')
		}
		if (final_filter["product_id"]) {
			final_filter['product_id'].values = convertTextToID(final_filter['product_id'], this.isServiceFilterList, 'name', 'id')
		}
		if (final_filter['drr_id']) {
			final_filter['drr_id'].values = convertTextToID(final_filter['drr_id'], this.isReturnResFilterList, 'name', 'id')
		}
		return { final_filter, final_sort }
	}

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid.api.deselectAll();
		this.setSelectAllArr([])
		this.setVisibleRowCount(0)
		this.setSelectedRowCount(0)
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow))
				}
				this.getList(payload).then((data) => {
					if (data.list.total === 0) { this.agGrid.api.showNoRowsOverlay() }
					else { this.agGrid.api.hideOverlay() }
					params.successCallback(data.list.data, data.list.total)
					var allColumnIds = []
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id)
						})
					}
				})
			}
		}
	}

	setVisibleRowCount = (data) => {
		this.visibleRowCount = data;
	}

	setSelectedRowCount = (data) => {
		this.selectedRowCount = data;
	}
	setIsSelectAll = (selectFlag) => {
		this.isSelectAll = selectFlag;

	}
	setSelectAllArr = (data) => {
		this.selectAllArr = data
	}

	onFirstDataRendered = () => {
		if (this.isSelectAll === true && this.agGrid) {
			this.agGrid.api.forEachNode((node) => {
				this.selectCount++;
				this.setSelectedRowCount(this.selectedRowCount + 1)
				node.setSelected(true);
			});
		}
	};

	onSelectAllRender = (selectAllFlag) => {
		if (selectAllFlag === true) {
			this.onFirstDataRendered();
		} else {
			this.agGrid.api.forEachNode((node) => {
				this.setSelectedRowCount(0);
				node.setSelected(false);
			});
		}
	};

	// Call add api
	AddData = (formdata) => {
		return Axios.post(`/bookings/return-to-origin/new`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call edit api
	EditData = (formdata) => {
		return Axios.post(`/bookings/return-to-origin/edit/` + formdata.id, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	ViewData = (ID) => {
		return Axios.get(`bookings/return-to-origin/details/${ID}`).then(({ data }) => {
			this.setViewValues(data.view);
			return data;
		});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return Axios.delete(`/bookings/return-to-origin/destroy/` + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ConsignmentData = (CO_NO) => {
		return Axios.get(`/bookings/consignment/details/${CO_NO}`).then(({ data }) => {
			this.setConsignmentValues(data.view)
			return data
		}).catch(({ response: { data } }) => {
			this.setConsignmentValues();
			var errors = [];
			const { NOTIFICATION } = data.STATUS;
			if (data && data.STATUS) {
				if (NOTIFICATION) {
					let name = "con_no";
					errors.push({ name, errors: NOTIFICATION });
				}
			}
			return Promise.reject({ errors });
		});
	}

	PrintReceiptData = (formData) => {
		return Axios.post(`bookings/return-to-origin/print-receipt`, formData).then(({ data }) => {
			return data;
		})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	}
	MultiPrintReceiptData = (formdata) => {
		return Axios.post(`bookings/return-to-origin/multi-print-receipt`, formdata).then(({ data }) => {
			if (this.agGrid) {
				this.setupGrid(this.agGrid)
				this.agGrid.api.deselectAll();
				this.setIsSelectAll(false)
				this.setSelectAllArr([])
				this.setSelectedRowCount(0)
				this.setVisibleRowCount(0);
			}
			return data;
		})
		.catch(({ response: { data } }) => {
			var errors = [];
			var notify = null;
			const { NOTIFICATION, ...fieldErrors } = data.STATUS;
			if (data && data.STATUS) {
				if (NOTIFICATION) {
					notify = NOTIFICATION[0];
				}
				Object.keys(fieldErrors).forEach((name) => {
					errors.push({ name, errors: data.STATUS[name] });
				});
			}
			return Promise.reject({ errors, notify });
		});
	}
}

decorate(ManageReturnToOriginEntryStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	statusValues: observable,
	total: observable,
	allColumnIds: observable,
	dropdown_city_list: observable,
	setupGrid: action,
	setStatusValues: action,
	setPageSize: action,
	setEditValues: action,
	setDeleteValues: action,
	getList: action,
	changeFilterAndSort: action,
	onFilterChanged: action,
	createDatasource: action,
	setViewValues: action,
	viewValues: observable,
	advance_filter: observable,
	setAdvanceFilterValues: action,
	setIsActiveFilterList: action,
	setBookingFilterList: action,
	isBookingFilter: observable,
	isActiveFilterList: observable,
	isServiceFilterList: observable,
	setServiceFilterList: action,
	isReturnResFilterList: observable,
	setIsReturnResFilterList: action,
	consignmentValues: observable,
	setConsignmentValues: action,
	setPrintValues: action,
	printValues:observable,
	selectionListEntries:observable,
	setSelectionListEntries:action,
	isSelectAll: observable,
	setIsSelectAll: action,
	visibleRowCount: observable,
	setVisibleRowCount: action,
	selectedRowCount: observable,
	setSelectedRowCount: action,
	selectAllArr: observable,
	setSelectAllArr: action,
});
